import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { numberFromStringSchema, stringSchema } from 'src/Configuration/validation/rules'
import { object, ObjectSchema } from 'yup'
import { ONLY_DIGITS_AND_LETTERS_REGEX } from './regex-patterns'
import { MeasurementsFormData } from '../../models/measurements'

const useMeasurementsValidation = (): {
  inProgressValidationSchema: ObjectSchema<Partial<MeasurementsFormData>>
  finalValidationSchema: ObjectSchema<MeasurementsFormData>
} => {
  const { t } = useCustomTranslation()
  const stringSchemaWithTranslation = stringSchema(t)
  const numberFromStringSchemaWithTranslation = numberFromStringSchema(t)
  const MAX_INPUT_LENGTH = 100
  const MIN_INPUT_LENGTH = 0

  const inProgressValidationSchema = object().shape({
    measurementDeviceManufacturer: stringSchemaWithTranslation({
      maxLength: MAX_INPUT_LENGTH,
      regexp: { rule: ONLY_DIGITS_AND_LETTERS_REGEX, errorMessage: t('validation.error-message.only-letters-and-digits-allowed') },
    }),
    measurementDeviceType: stringSchemaWithTranslation({
      maxLength: MAX_INPUT_LENGTH,
      regexp: { rule: ONLY_DIGITS_AND_LETTERS_REGEX, errorMessage: t('validation.error-message.only-letters-and-digits-allowed') },
    }),
    loopImpedanceNL1: numberFromStringSchemaWithTranslation({ min: MIN_INPUT_LENGTH }).nullable(),
    loopImpedanceNL2: numberFromStringSchemaWithTranslation({ min: MIN_INPUT_LENGTH }).nullable(),
    loopImpedanceNL3: numberFromStringSchemaWithTranslation({ min: MIN_INPUT_LENGTH }).nullable(),
    loopImpedancePEL: numberFromStringSchemaWithTranslation({ min: MIN_INPUT_LENGTH }).nullable(),
  })

  const finalValidationSchema: ObjectSchema<MeasurementsFormData> = object().shape({
    measurementDeviceManufacturer: stringSchemaWithTranslation({
      maxLength: MAX_INPUT_LENGTH,
      regexp: { rule: ONLY_DIGITS_AND_LETTERS_REGEX, errorMessage: t('validation.error-message.only-letters-and-digits-allowed') },
    }).required(),
    measurementDeviceType: stringSchemaWithTranslation({
      maxLength: MAX_INPUT_LENGTH,
      regexp: { rule: ONLY_DIGITS_AND_LETTERS_REGEX, errorMessage: t('validation.error-message.only-letters-and-digits-allowed') },
    }).required(),
    loopImpedanceNL1: numberFromStringSchemaWithTranslation({ min: MIN_INPUT_LENGTH }).nullable(),
    loopImpedanceNL2: numberFromStringSchemaWithTranslation({ min: MIN_INPUT_LENGTH }).nullable(),
    loopImpedanceNL3: numberFromStringSchemaWithTranslation({ min: MIN_INPUT_LENGTH }).nullable(),
    loopImpedancePEL: numberFromStringSchemaWithTranslation({ min: MIN_INPUT_LENGTH }).nullable(),
  })

  return { inProgressValidationSchema, finalValidationSchema }
}

export default useMeasurementsValidation
